import r from"./object-keys-internal.js";import t from"./enum-bug-keys.js";var n=r,o=t,s=Object.keys||function(e){return n(e,o)};export{s as default};
